<div class="modal-content-wrapper benefit-modal">

  <div class="benefit-modal__header">
    <h2 class="benefit-modal__title" [innerHTML]="data?.name"></h2>
    <button type="button" class="benefit-modal__close" aria-label="Lukk" (click)="close(true)">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  </div>

  <div class="modal-body benefit-details-container p-0">
    <div class="benefit" [class.benefit--no-aside]="!hasBenefitText">

      <div class="benefit__main">
        <img class="benefit__logo" *ngIf="logoUrl && !logoFailed" [src]="logoUrl" alt=""
             (error)="onLogoError()" />
        <h2 class="benefit__headline" *ngIf="data?.teaser" [innerHTML]="data?.teaser"></h2>
        <div class="ben-rich" [innerHTML]="data?.description"></div>
        <a class="ps-btn btn-primary custom-btn benefit__link" *ngIf="data?.urlWebsite"
           [href]="data?.urlWebsite" target="_blank" rel="noopener">
          <i class="bi bi-box-arrow-up-right" aria-hidden="true"></i> Gå til {{displayName}}
        </a>
      </div>

      <div class="benefit__aside" *ngIf="hasBenefitText">
        <h2 class="benefit__headline">Fordel</h2>
        <div class="ben-rich" [innerHTML]="data?.benefit"></div>
        <a class="ps-btn btn-primary custom-btn benefit__link" *ngIf="data?.urlWebsite"
           [href]="data?.urlWebsite" target="_blank" rel="noopener">
          <i class="bi bi-box-arrow-up-right" aria-hidden="true"></i> Gå til {{displayName}}
        </a>
      </div>

    </div>
  </div>

</div>
